/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.20.1.0 (NJsonSchema v9.11.0.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class CartItemAutoOptionsDTO
{
  autoOption: AutoOptionType;
  autoQuantity: AutoQuantityType;
}

export enum AutoOptionType
{
  Custom = 1,
  BestFit = 2,
}

export enum AutoQuantityType
{
  Custom = 1,
  OneSide = 2,
  TwoSides = 3,
  AllSides = 4,
  BestFit = 5,
}

export interface CartSubmitDTO
{
  grandTotal: number;


}

export interface CartUpdateDTO
{
  contactAddress?: Address;
  deliveryAddress?: Address;
  billingAdddress?: Address;
  addConsents?: string[];
  endConsents?: string[];
  customerComments?: string;

}

export interface Address
{
  iD?: number | null;
  firstName?: string;
  secondName?: string;
  company?: string;
  taxID?: string;
  city?: string;
  postCode?: string;
  street1?: string;
  street2?: string;
  state?: string;
  country?: string;
  countryCode?: string;
  personal?: boolean;
  phone?: string;
  email?: string;


}


export interface OrdersGetDTO
{
  fromDate?: Date;
  toDate?: Date;
  idFrom?: number;
  idTo?: number;
  status?: string;


}

export interface CartResultDTO
{
  cart?: Cart;


}


export interface Cart
{
  iD: number;
  items?: CartItem[];
  customerNote?: string;
  selectedPaymentMethod?: PaymentMethod;
  selectedDeliveryMethod?: DeliveryMethod;
  paymentMethods?: PaymentMethod[];
  deliveryMethods?: DeliveryMethod[];
  deliveryAddress?: Address;
  billingAddress?: Address;
  contactAddress?: Address;
  consents?: string[];
  discounts?: Discount[];
  couponCode?: string;
  couponMessage?: string;
  shippingTime?: ShippingTime;
  grandPromotionTotalBrutto: number;
  grandPromotionTotalNetto: number;
  subPromotionTotalBrutto: number;
  subPromotionTotalNetto: number;
  grandStandardTotalBrutto: number;
  grandStandardTotalNetto: number;
  subStandardTotalBrutto: number;
  subStandardTotalNetto: number;
  printedInvoiceRequested: boolean;
  smsNotificationsRequested: boolean;
  isReadyToSubmit: boolean;
  isReadyToSubmitInfo?: string[];

}

export interface CartItem
{
  iD: number;
  parentID?: number;
  product?: ShopProduct;
  disabled?: boolean;
  allProductOptions?: ShopProductOption[];
  subItems?: CartItem[];
  activeSubItems?: CartItem[];
  quantity: number;
  quantityType: QuantityType;
  quantityStep: number;
  squareMetters?: number;
  runningMetters?: number;
  shorterSide?: number;
  longerSide?: number;
  dimensions?: string;
  optionName?: string;
  option?: string;
  optionShort?: string;
  selectedAutoOptionType: AutoOptionType;
  autoOptionTypes?: AutoOptionType[];
  selectedAutoQuantityType: AutoQuantityType;
  autoQuantityTypes?: AutoQuantityType[];
  shippingTime?: ShippingTime;
  totalPromotionPriceBrutto: number;
  totalPromotionPriceNetto: number;
  unitPromotionPriceBrutto: number;
  unitPromotionPriceNetto: number;
  totalStandardPriceBrutto: number;
  totalStandardPriceNetto: number;
  unitStandardPriceBrutto: number;
  unitStandardPriceNetto: number;
  isDiscounted: boolean;
  active: boolean;

  //Custom
  expandedName?: string;
  cartQuantityUnit?: string;
}

export interface ShopProduct
{
  familyCode?: string;
  name?: string;
  url?: string;
  badge?: string;
  productType?: string;
  availableInStorages: string[];
  images?: MediaInfo[];
  complementaryProductFamilies?: ShopProductFamily[];
  shippingTime?: ShippingTime;
  iD: number;
  code?: string;
  option?: string;
  optionShort?: string;
  optionName?: string;
  promotionPrice: number;
  standardPrice: number;
  standardPricePerSquareMeters: number;
  promotionPricePerSquareMeters: number;
  priceBeforePromotion?: number;
  isUnique: boolean;
  isSplittable: boolean;
  isSample: boolean;
  width?: number;
  length?: number;
  quantityUnit?: string;
  priceUnit?: string;
  quantityUnitShort?: string;
  priceUnitShort?: string;
  daysToReturn?: number;
  isArchived: boolean;
  creationDate?: Date;
  promotionSince?: Date;

  // Custom
  isCarpet?: boolean;
  isWalkway?: boolean;
  isCovering?: boolean;
  isWiper?: boolean;
  selected?: boolean;
  selectedModal?: boolean;

}

export interface MediaInfo
{
  name?: string;
  index: number;
  productPageIndex?: number;
  position?: string;
  aspectRatio?: number;
  src?: string;
  width?: number;
  height?: number;
  url?: string;
  mediaType?: string;
}

export interface VideoInfo
{
  url?: string;
  name?: string;
  index: number;
  position?: string;
}

export interface ShopProductFamilyTag
{
  attributeCode?: string;
  name?: string;
  url?: string;
  weight: number;


}

export interface ShopProductFamily
{
  isArchived: boolean;
  isAnyProductSplitable: boolean;
  familyType?: string;
  familyCode?: string;
  promotionPrice: number;
  collectionFilter?: string;
  standardPrice: number;
  lowsetPromotionPrice: number;
  lowestPromotionPricePerSquareMeters: number;
  lowsetStandardPrice: number;
  lowestStandardPricePerSquareMeters: number;
  description?: string;
  hasDescription: boolean;
  url?: string;
  name?: string;
  collectionName?: string;
  parameterDescriptions?: string[];
  collectionDescription?: string;
  badge?: string;
  volumeUnit?: string;
  priceFromUnit?: string;
  accessoryProducts: ShopProduct[];
  images?: MediaInfo[];
  videos?: VideoInfo[];
  products?: ShopProduct[];
  complementaryProductFamilies?: ShopProductFamily[];
  attachements?: OrderAttachment[];
  parameters?: ShopProductParameter[];
  reviews?: ProductReview[];
  richResults?: string;
  title?: string;
  tags?: ShopProductFamilyTag[];
  breadcrumbs?: ShopProductFamilyTag[];

  // Custom
  isCarpet?: boolean;
  isWalkway?: boolean;
  isCovering?: boolean;
  isWiper?: boolean;

  mainImageIndex?: number;
}

export interface OrderAttachment
{
  iD: number;
  name?: string;
  url?: string;
  description?: string;
  attachmentType?: string;


}

export interface ShopProductParameter
{
  articleSection: string;
  articleUrl: string;
  caption: string;
  code: string;
  description: string;
  imageUrl: string;
  index: number;
  value: string;
}

export interface ProductFamilyImage
{
  index: number;
  name: string;
  position: string;
  variants: any[];


}

export interface ProductReview
{
  customerID: number;
  productFamilyCode?: string;
  anonymousUsername?: string;
  productName?: string;
  productLink?: string;
  productFamilyImage?: ProductFamilyImage;
  description?: string;
  rating: number;
  creationDate: Date;
  modifiedDate: Date;
  approved: boolean;
  deleted: boolean;


}

export interface ShippingTime
{
  deliveryDate?: Date;
  shippingtDate?: Date;
  validUntilDate: Date;
  priority: number;
  daysTimeLabel?: string;
  daysTimeLabelShort?: string;
  days?: number;
  additionalDaysTimeLabel?: string;
  shortAdditionalDaysTimeLabel?: string;
  additionalDays?: number;

}

export interface ShopProductOption
{
  iD: number;
  option?: string;
  promotionPrice: number;
  standardPrice: number;
  priceUnit?: string;


}

export enum QuantityType
{
  Pieces = 1,
  RunningMeters = 2,
  SquareMeters = 4,
}

export interface PaymentMethod
{
  iD: number;
  name?: string;
  code?: string;
  enabled: boolean;
  position: number;
  paymentUrl?: string;
  iconUrl?: string;

}

export enum DeliveryMethods
{
  KURIER_UPS = "kurier_ups",
  KURIER_UPS_PROBKI = "kurier_ups_probki",
  KURIER_UPS_POBRANIE = "kurier_ups_pobranie",
  KURIER_UPS_POBRANIE_PROBKI = "kurier_ups_pobranie_probki",
  ODBIOR_OSOBISTY = "odbior_osobisty"
}

export interface DeliveryMethod
{
  iD: number;
  name?: string;
  description?: string;
  code?: DeliveryMethods.KURIER_UPS | DeliveryMethods.KURIER_UPS_PROBKI | DeliveryMethods.KURIER_UPS_POBRANIE | DeliveryMethods.KURIER_UPS_POBRANIE_PROBKI | DeliveryMethods.ODBIOR_OSOBISTY;
  defaultPrice?: number;
  aboveItemsTotalPrice?: number;
  belowItemsTotalPrice?: number;
  distance?: number;
  stocks?: string;
  position: number;
  postCodeNeeded: boolean;
  grandTotalBrutto?: number;
  grandTotalNetto?: number;
  subItems?: DeliveryMethod[];
  iconUrl?: string;


}

export interface Discount
{
  description?: string;
  discountValue: number;
  discountType: DiscountType;
  priority: number;
  exclusive: boolean;
  couponCode?: string;

}

export enum DiscountType
{
  Additive = 0,
  Multiplicative = 1,
}

export interface ContentResultDTO
{
  content?: Content[];


}

export interface Content
{
  iD: number;
  title?: string;
  code?: string;
  route?: string;
  createdDate: Date;
  enabled: boolean;
  contentType?: string;
  metaDescription?: string;
  metaKeywords?: string;
  resolvedContent?: string;
  resolvedJson?: any;
  format?: string;
  sidebars?: string[];


}

export interface CustomerConnectDTO
{
  externalAuthenticatorName?: string;
  externalAuthenticatorCustomerToken?: string;

}

export interface CustomerContactRequestDTO
{
  customerContactRequest?: CustomerContactRequestVO;

}

export interface CustomerContactRequestVO
{
  contactFormCode?: string;
  customerName?: string;
  customerEmail?: string;
  customerPhone?: string;
  customerMessage?: string;
  whenToContact?: string;
  productName?: string;
  productCode?: string;


}

export interface CustomerLoginDTO
{
  email?: string;
  password?: string;


}

export interface CustomerPasswordChangeDTO
{
  oldPassword?: string;
  newPassword?: string;


}

export interface CustomerPasswordResetDTO
{
  passwordResetRequestToken?: string;
  newPassword?: string;


}


export interface CustomerPasswordResetRequestDTO
{
  email?: string;

}

export interface CustomerPasswordResetRequestValidateDTO
{
  passwordResetRequestToken?: string;


}

export interface CustomerProductReviewDTO
{
  productFamilyCode?: string;
  anonymousUsername?: string;
  description?: string;
  rating: number;
  addConsents?: string[];


}


export interface CustomerRegisterDTO
{
  email?: string;
  password?: string;
  addConsents?: string[];


}


export interface CustomerUpdateDTO
{
  email?: string;
  password?: string;
  newPassword?: string;
  passwordToken?: string;
  contactAddress?: Address;
  rememberPassword?: boolean;
  deliveryAddress?: Address;
  billingAdddress?: Address;
  addConsents?: string[];
  endConsents?: string[];
  device?: Device;


}

export interface Device
{
  inputDeviceType: InputDeviceType;
  deviceType: DeviceType;
  screenWidth: number;
  screenHeight: number;
  browser?: string;


}

export enum InputDeviceType
{
  Keyboard = 0,
  Touchscreen = 1,
}

export enum DeviceType
{
  PC = 0,
  Tablet = 1,
  Phone = 2,
}

export interface SessionDTO
{
  session?: Session;


}

export interface Session
{
  token?: string;
  customer?: Customer;
  status: CustomerStatus;


}

export interface Coupon
{
  code?: string;
  endDate?: Date;
  fallbackImage: string;
  image?: string;
  name?: string;


}

export interface Customer
{
  iD: number;
  email?: string;
  isRegistered: boolean;
  defaultBillingAddress?: Address;
  defaultDeliveryAddress?: Address;
  defaultContactAddress?: Address;
  consents?: CustomerConsent[];
  device?: Device;
  orders?: Order[];
  coupons?: Coupon[];
  cart?: Cart;
  guid: string;
  wishlist?: Wishlist;
  notifications?: CustomerNotification[];
  externalAuthentications?: ExternalAuthentication[];
  productReviews?: ProductReview[];
  newsletter?: Newsletter;
  timestamp: number;

}

export interface CustomerConsent
{
  name?: string;
  code?: string;
  type: string;
  description?: string;
  consentStartDate: Date;
  consentEndDate?: Date;
  active: boolean;


}

export interface Order
{
  iD: number;
  token?: string;
  notifications?: CustomerNotification[];
  consents?: CustomerConsent[];
  currentTransaction?: PaymentTransaction;
  transactions?: PaymentTransaction[];
  attachments?: OrderAttachment[];
  shipments?: OrderShipment[];
  returns?: OrderReturn[];
  status?: string;
  items?: OrderItem[];
  discounts?: Discount[];
  paymentMethod?: PaymentMethod;
  deliveryMethod?: DeliveryMethod;
  productsTotalBrutto: number;
  shipmentTotalBrutto: number;
  totalBrutto: number;
  deliveryAddress?: Address;
  billingAddress?: Address;
  contactAddress?: Address;
  privateNote?: string;
  publicNote?: string;
  customerNote?: string;
  creationDate: Date;
  finishedDate?: Date;
  expectedDeliveryDate?: Date;
  actualDeliveryDate?: Date;
  expectedShipmentDate?: Date;
  actualShipmentDate?: Date;
  overridedExpectedDeliveryDate?: Date;
  overridedExpectedShipmentDate?: Date;
  printedInvoiceRequested: boolean;
  smsNotificationsRequested: boolean;


}

export interface CustomerNotification
{
  sentDate: Date;
  title?: string;
  content?: string;
  recipients?: string;
  orderID?: number;
  customerID?: number;
  category?: string;


}

export interface PaymentTransaction
{
  provider?: string;
  paymentUrl?: string;
  description?: string;
  totalAmount: number;
  status?: string;
  creationDate: Date;
  localReciptDateTime?: Date;


}

export interface OrderShipment
{
  shipmentCode?: string;
  trackingCode?: string;
  trackingUrl?: string;
  creationDate: Date;
  shippingDate?: Date;
  deliveryDate?: Date;
  status?: string;
  items?: OrderShipmentItem[];


}

export interface OrderShipmentItem
{
  productID: number;
  orderItemId?: number;
  productName?: string;
  productOption?: string;
  productOptionName?: string;
  productQuantity: number;
  productUnitPrice: number;

}

export interface OrderReturn
{
  iD: number;
  shopInstance: number;
  orderID: number;
  creationDate: Date;
  orderDeliveryDate: Date;
  status?: string;
  returnDeliveryOption?: string;
  returnAccountNumber?: string;
  returnDeliveryPrice: number;
  returnDeliveryDescription?: string;
  returnDeliveryAddress?: Address;
  items?: OrderReturnItem[];

}

export interface OrderReturnItem
{
  iD: number;
  shopInstance: number;
  orderReturnID: number;
  orderItemID: number;
  quantity: number;


}

export interface OrderItem
{
  product?: ShopProduct;
  subItems?: OrderItem[];
  iD: number;
  productID: number;
  productName?: string;
  optionName?: string;
  option?: string;
  optionShort?: string;
  productOption?: string;
  productOptionName?: string;
  quantity: number;
  deleted: boolean;
  returnStartedQuantity: number;
  returnFinishedQuantity: number;
  sentQuantity: number;
  deliveredQuantity: number;
  unitDiscountedPriceBrutto: number;
  totalDiscountedPriceBrutto: number;
  unitOriginalPriceBrutto: number;
  totalOriginalPriceBrutto: number;
  expectedDeliveryDate?: Date;
  expectedShippmentDate?: Date;
  actualDeliveryDate?: Date;
  actualShippmentDate?: Date;
  quantityUnit?: string;
  priceUnit?: string;
  daysToReturn: number;
  daysToFinalDateOfReturn?: number;
  finalDateOfReturn?: Date;


}

export interface Wishlist
{
  products?: ShopProductFamily[];
}

export interface ExternalAuthentication
{
  providerName?: string;
  createdDate: Date;
  deleted: boolean;


}

export interface Newsletter
{

}

export enum CustomerStatus
{
  New = 0,
  Existing = 1,
}

export interface ShopReviewsResultDTO
{
  reviews?: ShopReview[];


}

export interface ShopReview
{
  nick?: string;
  description?: string;
  creationDate: Date;


}

export interface ExceptionResultDTO
{
  type?: string;
  message?: string;
  statusCode: number;
  stackTrace?: string;


}


export interface OrderGetDTO
{
  orderID?: number;
  orderToken?: string;
  secondName?: string;

}

export interface OrderPrintedInvoiceRequestDTO
{
  orderID?: number;
  orderToken?: string;
  requestPrintedInvoice: boolean;


}

export interface OrderReturnRequestDTO
{
  orderReturnRequest?: OrderReturnRequestVO;
  orderID?: number;
  orderToken?: string;


}

export interface OrderReturnRequestVO
{
  orderDeliveryDate: Date;
  returnDeliveryOption?: string;
  returnPaymentOption?: string;
  returnOrderID?: string;
  returnAccountNumber?: string;
  returnDeliveryPrice: number;
  returnDeliveryDescription?: string;
  returnDeliveryAddress?: Address;
  items?: OrderReturnRequestItemVO[];


}

export interface OrderReturnRequestItemVO
{
  orderItemID: number;
  quantity: number;

}

export interface OrderShippmentDateChangeDTO
{
  orderID?: number;
  orderToken?: string;
  shipmentDate: Date;


}

export interface OrderSmsNotificationsRequestDTO
{
  orderID?: number;
  orderToken?: string;
  requestSmsNotifications: boolean;


}

export interface OrderStatusUpdateDTO
{
  orderID: number;
  shipments?: OrderShipmentVO[];
  attachments?: OrderAttachmentVO[];


}

export interface OrderShipmentVO
{
  shipmentCode?: string;
  tracking?: string;
  creationDate: Date;
  shippingDate: Date;
  deliveryDate: Date;
  status?: string;
  items?: OrderShipmentItemVO[];


}

export interface OrderShipmentItemVO
{
  productID: number;
  productName?: string;
  productOption?: string;
  productOptionName?: string;
  productQuantity: number;
  productUnitPrice: number;


}

export interface OrderAttachmentVO
{
  name?: string;
  uRL?: string;
  description?: string;
  attachmentType?: string;


}

export interface OrderResultDTO
{
  order?: Order;


}

export interface OrdersResultDTO
{
  orders?: Order[];


}

export interface StatusResultDTO
{
  status: boolean;


}

export interface WishlistResultDTO
{
  wishlist?: Wishlist;


}
